<cfp-login-layout>
  <cfp-login-card [title]="'login.reset' | translate">
    <cfp-login-loading-spinner [loading]="loginLoading" />

    @if (form) {
      <form class="modal-content" (submit)="send()" [formGroup]="form" data-test="passwordResetForm">
        <cfp-new-password-form
          [form]="form"
          [isFormSubmitted]="isSubmitted"
          [serverValidationErrors]="serverValidationErrors()"
          [loginProperties]="loginProperties()"
          [showErrorMessageNewPasswordAlreadyUsed]="false"
        />

        @if (showAgreeTermsAndConditions) {
          <cfp-input-checkbox [id]="'agreeTermsAndConditions'" formControlName="agreeTermsAndConditions">
            <cfp-translated-router-link
              [text]="'agreeTermsAndConditions.label'"
              (linkClick)="showTermsAndConditions()"
              prependLabel
            />
          </cfp-input-checkbox>
          @if (isSubmitted && showValidation('agreeTermsAndConditions', 'required')) {
            <div class="validation-feedback text-danger mt-2">
              <i class="fa fa-exclamation"></i>
              {{ 'agreeTermsAndConditions.validation' | translate }}
            </div>
          }
        }
        @if (showAgreeTermsOfUse) {
          <cfp-input-checkbox [id]="'agreeTermsOfUse'" formControlName="agreeTermsOfUse">
            <cfp-translated-router-link prependLabel [text]="'agreeTermsOfUse.label'" (linkClick)="showTermsOfUse()" />
          </cfp-input-checkbox>

          @if (isSubmitted && showValidation('agreeTermsOfUse', 'required')) {
            <div class="validation-feedback text-danger mt-2">
              <i class="fa fa-exclamation"></i>
              {{ 'agreeTermsOfUse.validation' | translate }}
            </div>
          }
        }
        <div class="mt-4">
          <cfp-button [id]="'btnSubmit'" [type]="'submit'" [classes]="'w-100'" dataTest="resetPasswordButton">
            {{ 'login.submit' | translate }}
          </cfp-button>
        </div>
      </form>
      <cfp-login-sso />
    }
  </cfp-login-card>
</cfp-login-layout>
